import { render, staticRenderFns } from "./calligraphy.vue?vue&type=template&id=63593970&scoped=true"
import script from "./calligraphy.vue?vue&type=script&lang=js"
export * from "./calligraphy.vue?vue&type=script&lang=js"
import style0 from "./calligraphy.vue?vue&type=style&index=0&id=63593970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63593970",
  null
  
)

export default component.exports